import React, { useEffect, useState } from 'react'

import getYears, { GetYearsOptions, Year } from 'api/vehicles/getYears'
import { FormikDropdown } from 'components/FormikFields'
import { FormikDropdownChild } from 'components/FormikFields/FormikDropdown/FormikDropdown'

interface QueryProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formik: any
    dataSource?: string[]
    assetType?: unknown
    assetSubType?: unknown
}

const defaultProps = {
    dataSource: null,
    assetType: null,
    assetSubType: null,
}

export default function YearDropdown({
    formik,
    dataSource,
    assetType,
    assetSubType,
}: Readonly<QueryProps>) {
    const [response, updateResponse] = useState([] as Year[])
    const { marine } = formik.values
    const { year, condition, type } = marine

    function getYearsForMarine(abortController: AbortController) {
        const getYearsOptions = {
            condition: condition === 'N' ? 'new' : 'used',
            dataSource,
            boatType: type,
            assetType,
            assetSubType,
        } as GetYearsOptions

        getYears(getYearsOptions, abortController)
            .then((yearsOptions: Year[]) => {
                updateResponse(yearsOptions)

                if (
                    yearsOptions.filter((e) => `${e.id}` === year).length === 0
                ) {
                    formik.setFieldValue('marine.year', '')
                }
            })
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .catch(() => {})
    }

    useEffect(() => {
        const abortController = new AbortController()

        if (condition) {
            getYearsForMarine(abortController)
        }

        return () => abortController.abort()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [condition, type])

    if (response.length < 1) {
        return (
            <FormikDropdown
                name="marine.year"
                label="Year"
                placeholder="Select Year"
                disabled
            >
                {{ name: '', value: '' }}
                {{ name: '', value: '' }}
            </FormikDropdown>
        )
    }

    return (
        <FormikDropdown
            name="marine.year"
            label="Year"
            placeholder="Select Year"
            disabled={response.length === 0}
            error={year === null || year === 0}
        >
            {response.map((child: Year) => {
                const newBorn: FormikDropdownChild = {
                    name: child.id.toString(),
                    value: child.id.toString(),
                }

                return newBorn
            })}
        </FormikDropdown>
    )
}

YearDropdown.defaultProps = defaultProps
